import { ButtonLink } from '@app/components/base/ButtonLink';
import { Page } from '@app/components/page/Page';
import { StationIcon } from '@app/components/stations/StationIcon';
import { StationCtxProvider } from '@app/core/containers/StationCtx';
import { useStation } from '@app/core/stations/hooks/useStation';
import { ConnAdminStationsGroupsPermissionsView } from '@app/modules/admin/screens/stations/groups-permissions/AdminStationsGroupsPermissionsView';
import { ConnAdminStationsUsersPermissionsView } from '@app/modules/admin/screens/stations/users-permissions/AdminStationsUsersPermissionsView';
import { StationInfo } from '@app/modules/admin/screens/stations/view/StationInfo';
import { capitalizeFirst } from '@mi-front/core';
import { ParamDrivenTabsMui } from '@mi-front/ui';
import EditIcon from '@mui/icons-material/Edit';
import { useParams } from 'react-router-dom';
import { FormattedMessage, useIntl } from 'react-intl';
import { AdminStationsBreadcrumbs } from '../header';
import { StationLabel } from '../list/StationLabel';

export enum TabKey {
  INFO = 'info',
  GROUPS_PERMISSIONS = 'groups-permissions',
  USERS_PERMISSIONS = 'users-permissions',
}

export function AdminStationsViewPage() {
  const { slug } = useParams<{ slug: string }>();
  const { $t, formatMessage } = useIntl();
  const station = useStation(slug);

  const tabs = [
    {
      value: TabKey.INFO,
      label: (
        <FormattedMessage id="admin.stations.viewScreen.basicInfo" defaultMessage="Info básica" />
      ),
      content: <StationInfo station={station} />,
    },
    {
      value: TabKey.GROUPS_PERMISSIONS,
      label: (
        <FormattedMessage
          id="admin.stations.viewScreen.groupsPermissions"
          defaultMessage="Permisos de grupos"
        />
      ),
      content: <ConnAdminStationsGroupsPermissionsView slug={station.slug} />,
    },
    {
      value: TabKey.USERS_PERMISSIONS,
      label: (
        <FormattedMessage
          id="admin.stations.viewScreen.usersPermissions"
          defaultMessage="Permisos de usuarios"
        />
      ),
      content: <ConnAdminStationsUsersPermissionsView slug={station.slug} />,
    },
  ];

  return (
    <StationCtxProvider station={station}>
      <Page
        htmlTitle={`${capitalizeFirst(
          $t({
            id: 'common.entities.station',
            defaultMessage: 'emisora',
          }),
        )} ${station.name}`}
      >
        <Page.Header
          icon={<StationIcon />}
          title={<StationLabel station={station} />}
          breadcrumbs={<AdminStationsBreadcrumbs title={station.name} />}
          actions={
            <ButtonLink
              to={`/admin/stations/${station.slug}/edit`}
              variant="outlined"
              startIcon={<EditIcon />}
            >
              {formatMessage({
                id: 'common.actions.edit',
                defaultMessage: 'Editar',
              })}
            </ButtonLink>
          }
        />
        <Page.Content>
          <ParamDrivenTabsMui id="station-view-tabs" tabs={tabs} />
        </Page.Content>
      </Page>
    </StationCtxProvider>
  );
}
